/* ============================================================
   Cart Gift Rewards — free gift + free sample picker
   ============================================================ */
(function () {
  'use strict';

  var configEl = document.getElementById('CartGiftRewardsConfig');
  if (!configEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!CONFIG || !CONFIG.enabled) return;

  var PER_PAGE = CONFIG.perPage || 2;
  var giftItems = (CONFIG.giftEnabled && CONFIG.gift && CONFIG.gift.items) || [];
  var sampleItems = (CONFIG.sampleEnabled && CONFIG.sample && CONFIG.sample.items) || [];

  var giftIds = idSet(giftItems);
  var sampleIds = idSet(sampleItems);

  var isMutating = false; // guards re-entrancy during add/remove

  function idSet(items) {
    var s = {};
    items.forEach(function (it) { s[String(it.id)] = true; });
    return s;
  }

  function variantId(item) {
    return String(item.variant_id != null ? item.variant_id : item.id);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  // Subtotal of everything EXCEPT reward lines — what the threshold is measured against.
  function qualifyingSubtotal(cart) {
    var total = 0;
    cart.items.forEach(function (item) {
      var id = variantId(item);
      if (giftIds[id] || sampleIds[id]) return;
      total += item.final_line_price != null ? item.final_line_price : item.line_price;
    });
    return total;
  }

  function selectedRewardId(cart, ids) {
    for (var i = 0; i < cart.items.length; i++) {
      if (ids[variantId(cart.items[i])]) return variantId(cart.items[i]);
    }
    return null;
  }

  function lineIndexOf(cart, vid) {
    for (var i = 0; i < cart.items.length; i++) {
      if (variantId(cart.items[i]) === String(vid)) return i + 1; // Shopify lines are 1-based
    }
    return -1;
  }

  /* ---------- Cart mutations ---------- */

  function addReward(vid, type) {
    var props = {};
    props['_' + type] = 'true';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
    });
  }

  function removeLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    });
  }

  function refreshDrawer() {
    // Rebuild the drawer the same way the theme does; this re-fires ajaxCart.afterCartLoad.
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      window.ajaxCart.load();
    } else {
      render();
    }
  }

  // Lock the cart panel to its current height so the pinned footer doesn't jump
  // during the remove→add cycle when swapping a reward.
  function lockCartPanel() {
    var panel = document.querySelector('.cart-side-panel');
    if (panel && !panel.dataset.cgrLocked) {
      panel.dataset.cgrLocked = '1';
      panel.style.minHeight = panel.offsetHeight + 'px';
    }
  }

  function unlockCartPanel() {
    var panel = document.querySelector('.cart-side-panel');
    if (panel) {
      panel.style.minHeight = '';
      delete panel.dataset.cgrLocked;
    }
  }

  // Toggle a reward selection: deselect if clicking the current one, otherwise swap.
  function selectReward(type, vid) {
    if (isMutating) return;
    isMutating = true;
    lockCartPanel();
    var ids = type === 'gift' ? giftIds : sampleIds;

    fetchCart().then(function (cart) {
      var current = selectedRewardId(cart, ids);
      var chain = Promise.resolve();

      if (current) {
        chain = chain.then(function () { return removeLine(lineIndexOf(cart, current)); });
      }
      // Clicking the already-selected card just removes it (deselect).
      if (current !== String(vid)) {
        chain = chain.then(function () { return addReward(vid, type); });
      }
      return chain;
    }).then(function () {
      isMutating = false;
      refreshDrawer();
    }).catch(function () {
      isMutating = false;
      refreshDrawer();
    });
  }

  /* ---------- Rendering ---------- */

  function cardHTML(item, type, isSelected) {
    var badge = type === 'gift' ? 'Gift' : 'Sample';
    return (
      '<button type="button" class="cgr__card' + (isSelected ? ' is-selected' : '') + '"' +
        ' data-cgr-type="' + type + '" data-cgr-id="' + item.id + '"' +
        (item.available ? '' : ' disabled') + '>' +
        '<span class="cgr__check" aria-hidden="true">&#10003;</span>' +
        '<span class="cgr__badge">' + badge + '</span>' +
        '<span class="cgr__card-media">' +
          (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
        '</span>' +
        '<span class="cgr__card-title">' + escapeHTML(item.title) + '</span>' +
        (item.value && type === 'gift' ? '<span class="cgr__card-value">' + item.value + ' value</span>' : '') +
      '</button>'
    );
  }

  function sectionHTML(opts) {
    // opts: { type, heading, terms, items, selectedId, locked, lockedNote }
    var cards = opts.items.map(function (it) {
      return cardHTML(it, opts.type, String(it.id) === String(opts.selectedId));
    }).join('');

    var pages = Math.ceil(opts.items.length / PER_PAGE);
    var dots = '';
    for (var p = 0; p < pages; p++) {
      dots += '<button type="button" class="cgr__dot' + (p === 0 ? ' is-active' : '') +
              '" data-cgr-page="' + p + '" aria-label="Page ' + (p + 1) + '"></button>';
    }

    var lockNote = '';
    if (opts.locked && opts.lockedNote) {
      lockNote =
        '<div class="cgr__locked-note">' +
          '<svg width="11" height="13" viewBox="0 0 11 13" fill="none"><path d="M2 5V3.5a3.5 3.5 0 117 0V5" stroke="#FF9F98" stroke-width="1.3"/><rect x="1" y="5" width="9" height="7" rx="1.5" fill="#FF9F98"/></svg>' +
          '<span>' + escapeHTML(opts.lockedNote) + '</span>' +
        '</div>';
    }

    return (
      '<div class="cgr__section' + (opts.locked ? ' is-locked' : '') + '" data-cgr-section="' + opts.type + '">' +
        '<span class="cgr__heading">' + escapeHTML(opts.heading) + '</span>' +
        (opts.terms ? '<div class="cgr__terms">' + opts.terms + '</div>' : '') +
        lockNote +
        '<div class="cgr__viewport">' +
          '<div class="cgr__track">' + cards + '</div>' +
          '<div class="cgr__dots' + (pages <= 1 ? ' cgr__dots--hidden' : '') + '">' + dots + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function moneyFmt(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  // Reserve scroll space below the carousels so they clear the absolutely-pinned
  // footer. The footer height can change after render (DiscountNinja injects promo
  // /discount rows async), so we re-measure on resize.
  function syncFooterClearance() {
    var wrap = document.getElementById('cgr-root');
    var footer = document.querySelector('.block-cart-footer');
    if (wrap && footer) {
      // Floor at 190px so the carousel always clears the footer even if a height
      // measurement comes back small mid-rebuild.
      wrap.style.paddingBottom = Math.max(footer.offsetHeight + 28, 190) + 'px';
    }
  }

  var footerRO = window.ResizeObserver ? new ResizeObserver(syncFooterClearance) : null;
  function observeFooter() {
    if (!footerRO) return;
    footerRO.disconnect();
    var footer = document.querySelector('.block-cart-footer');
    if (footer) footerRO.observe(footer);
  }

  function render(cart) {
    // Mount at the end of the SCROLLING items list (not the absolutely-pinned footer),
    // so the carousels scroll with the cart and never overlap items or the footer.
    var mount = document.querySelector('.cart-middle-items');
    if (!mount) return;

    if (!cart) {
      fetchCart().then(render);
      return;
    }

    var qualifying = qualifyingSubtotal(cart);
    var threshold = CONFIG.thresholdCents || 0;
    var unlocked = qualifying >= threshold;
    var html = '';

    // ---- Gift section (threshold-gated) ----
    if (giftItems.length) {
      var selectedGift = selectedRewardId(cart, giftIds);

      // Auto-remove the gift if the cart dropped below the threshold.
      if (selectedGift && !unlocked && !isMutating) {
        isMutating = true;
        removeLine(lineIndexOf(cart, selectedGift)).then(function () {
          isMutating = false;
          refreshDrawer();
        });
        return;
      }

      var remaining = threshold - qualifying;
      var lockedNote = !unlocked
        ? (CONFIG.gift.lockedText || 'Spend {{amount}} more to unlock your free gift')
            .replace('{{amount}}', moneyFmt(remaining))
        : '';

      html += sectionHTML({
        type: 'gift',
        heading: CONFIG.gift.heading || 'FREE gift with your order',
        terms: CONFIG.gift.terms || '',
        items: giftItems,
        selectedId: selectedGift,
        locked: !unlocked,
        lockedNote: lockedNote
      });
    }

    // ---- Sample section (every order) ----
    if (sampleItems.length) {
      html += sectionHTML({
        type: 'sample',
        heading: CONFIG.sample.heading || 'Select a free sample',
        terms: CONFIG.sample.terms || '',
        items: sampleItems,
        selectedId: selectedRewardId(cart, sampleIds),
        locked: false,
        lockedNote: ''
      });
    }

    var wrap = document.getElementById('cgr-root');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.id = 'cgr-root';
      wrap.className = 'cgr';
      mount.appendChild(wrap);
    }
    wrap.style.setProperty('--cgr-per', PER_PAGE);
    wrap.innerHTML = html;

    // Clear the pinned footer now, again after async footer rows settle, and on resize.
    syncFooterClearance();
    observeFooter();
    setTimeout(syncFooterClearance, 400);

    decorateRewardLines(cart);
    initDots(wrap);
    // Release height lock now that the full render is complete.
    unlockCartPanel();
  }

  // Mark reward lines in the cart list as FREE and strip qty/remove controls.
  function decorateRewardLines(cart) {
    cart.items.forEach(function (item) {
      var id = variantId(item);
      var isGift = !!giftIds[id];
      var isSample = !!sampleIds[id];
      if (!isGift && !isSample) return;
      var type = isGift ? 'gift' : 'sample';
      var badgeLabel = isGift ? 'Gift' : 'Sample';

      var rows = document.querySelectorAll('.product-handle-' + id);
      rows.forEach(function (row) {
        row.classList.add('cart-reward-line');

        // Badge overlay on the product image
        var imgWrap = row.querySelector('.cart-image-part');
        if (imgWrap && !imgWrap.querySelector('.cgr-line-badge')) {
          var badge = document.createElement('span');
          badge.className = 'cgr-line-badge';
          badge.textContent = badgeLabel;
          imgWrap.appendChild(badge);
        }

        // Hide the theme's × button — we add our own "remove" text link below.
        var xBtn = row.querySelector('.cart-remove');
        if (xBtn) xBtn.style.display = 'none';

        // Price: gift shows struck compare price (from config, not cart.js — Shopify
        // suppresses compare_at_price on $0 line items) stacked above "free".
        var price = row.querySelector('.cart_price');
        if (price) {
          var configItem = null;
          var allConfigItems = giftItems.concat(sampleItems);
          for (var ci = 0; ci < allConfigItems.length; ci++) {
            if (String(allConfigItems[ci].id) === id) { configItem = allConfigItems[ci]; break; }
          }
          var configValue = configItem && configItem.value && configItem.value !== '$0.00' ? configItem.value : null;
          var compareHtml = (isGift && configValue)
            ? '<del class="cgr-original-price">' + configValue + '</del>'
            : '';
          price.innerHTML = '<span class="cgr-price-stack">' + compareHtml + '<span class="cgr-free-tag">free</span></span>';
        }

        // "remove" text link at the bottom of the cart-right column.
        var cartRight = row.querySelector('.cart-right');
        if (cartRight && !cartRight.querySelector('.cgr-remove-btn')) {
          var removeWrap = document.createElement('div');
          removeWrap.className = 'cgr-remove-wrap';
          var removeLink = document.createElement('button');
          removeLink.type = 'button';
          removeLink.className = 'cgr-remove-btn';
          removeLink.setAttribute('data-cgr-remove-type', type);
          removeLink.setAttribute('data-cgr-remove-id', id);
          removeLink.textContent = 'remove';
          removeWrap.appendChild(removeLink);
          cartRight.appendChild(removeWrap);
        }
      });
    });
  }

  /* ---------- Dots / carousel sync ---------- */

  function initDots(root) {
    root.querySelectorAll('.cgr__section').forEach(function (section) {
      var track = section.querySelector('.cgr__track');
      var dots = section.querySelectorAll('.cgr__dot');
      if (!track || dots.length <= 1) return;

      track.addEventListener('scroll', function () {
        var page = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === page);
        });
      }, { passive: true });
    });
  }

  /* ---------- Events ---------- */

  function escapeHTML(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Single delegated handler for card, dot, and remove-button clicks.
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.cgr__card');
    if (card && !card.disabled) {
      selectReward(card.getAttribute('data-cgr-type'), card.getAttribute('data-cgr-id'));
      return;
    }
    var removeBtn = e.target.closest && e.target.closest('.cgr-remove-btn');
    if (removeBtn) {
      selectReward(removeBtn.getAttribute('data-cgr-remove-type'), removeBtn.getAttribute('data-cgr-remove-id'));
      return;
    }
    var dot = e.target.closest && e.target.closest('.cgr__dot');
    if (dot) {
      var section = dot.closest('.cgr__section');
      var track = section && section.querySelector('.cgr__track');
      if (track) {
        track.scrollTo({ left: track.clientWidth * parseInt(dot.getAttribute('data-cgr-page'), 10), behavior: 'smooth' });
      }
    }
  });

  /* ---------- Robust render triggers ----------
     The cart body (#cart_container_id) is rebuilt client-side, lazily, and only
     when the drawer first builds — so events/jQuery may not be ready when this
     script runs. A MutationObserver on the persistent container re-renders us
     every time the cart body changes, independent of that timing. */

  var lastSig = '';
  var debounceTimer = null;

  function cartSignature(cart) {
    return cart.item_count + '|' + cart.items.map(function (i) {
      return variantId(i) + 'x' + i.quantity;
    }).join(',');
  }

  function maybeRender() {
    var mount = document.querySelector('.cart-middle-items');
    if (!mount) return; // cart not built yet (or empty)
    fetchCart().then(function (cart) {
      var sig = cartSignature(cart);
      var hasRoot = !!document.getElementById('cgr-root');
      if (sig === lastSig && hasRoot) return; // unchanged and already mounted — avoids observer loop
      lastSig = sig;
      render(cart);
    });
  }

  function scheduleRender() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(maybeRender, 80);
  }

  function startObserver() {
    var container = document.getElementById('cart_container_id');
    if (!container) { setTimeout(startObserver, 300); return; }
    new MutationObserver(scheduleRender).observe(container, { childList: true, subtree: true });
    scheduleRender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  // Supplementary triggers — harmless duplicates are filtered by the signature check.
  document.addEventListener('cart:updated', scheduleRender);
  (function bindJQ() {
    if (window.jQuery) {
      jQuery('body').on('ajaxCart.afterCartLoad', scheduleRender);
    } else {
      setTimeout(bindJQ, 250);
    }
  })();
})();
